/**
 * Kinng.app — Clube de Assinatura API.
 */
import api, { auth } from "./api";

export const subscriptionsApi = {
    // Plans
    listPlans: () => api.get("/tenant/subscription-plans"),
    createPlan: (body) => api.post("/tenant/subscription-plans", body),
    updatePlan: (id, body) => api.patch(`/tenant/subscription-plans/${id}`, body),
    deletePlan: (id) => api.del(`/tenant/subscription-plans/${id}`),

    // Subscriptions
    list: (params = {}) => {
        const qs = new URLSearchParams(
            Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "" && v !== "all")
        ).toString();
        return api.get(`/tenant/subscriptions${qs ? `?${qs}` : ""}`);
    },
    get: (id) => api.get(`/tenant/subscriptions/${id}`),
    create: (body) => api.post("/tenant/subscriptions", body),
    renew: (id, body) => api.patch(`/tenant/subscriptions/${id}/renew`, body),
    cancel: (id, body) => api.patch(`/tenant/subscriptions/${id}/cancel`, body),
    use: (id, body) => api.patch(`/tenant/subscriptions/${id}/use`, body),
    changePlan: (id, planId) => api.patch(`/tenant/subscriptions/${id}/change-plan`, { plan_id: planId }),
    registerPayment: (id, body) => api.post(`/tenant/subscriptions/${id}/payment`, body),
    getByClient: (clientId) => api.get(`/tenant/subscriptions/client/${clientId}`),

    // Revenue
    summary: () => api.get("/tenant/subscriptions/revenue/summary"),
    history: () => api.get("/tenant/subscriptions/revenue/history"),
    exportCsvUrl: (period) => {
        const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
        return `${base}/api/tenant/subscriptions/revenue/export${period ? `?period=${period}` : ""}`;
    },
    exportCsvDownload: async (period) => {
        const token = auth.getToken() || auth.getAdminToken();
        const res = await fetch(subscriptionsApi.exportCsvUrl(period), {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.blob();
    },
};

export default subscriptionsApi;
